module.exports = __webpack_public_path__ + "img/KM-360A_09.cf9196fb.jpg";